import { permissions, permissionsConstant} from "../constants/roles.constants";
// import { appUtils } from "../../../utils/app.utils";

const initialState = {
  loading: false,
  success: false,
  request: null,
  response: null,
  error: null
};

export const getRolesPermissions = (state = initialState, action) => {
  switch (action.type) {
    case permissionsConstant[`GET_${permissions}_REQUEST`]:
      return {
        ...state,
        loading: true,
        request: action.request
      };
    case permissionsConstant[`GET_${permissions}_SUCCESS`]:
      return {
        ...state,
        loading: false,
        success: true,
        response: action.response,
        error: null
      };
       
    case permissionsConstant[`GET_${permissions}_FAILURE`]:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.error
      };
    case permissionsConstant[`GET_${permissions}_RESET`]:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
